/**
 * 服务条款页 - 含 WhatsApp、企业微信、Google 日历等使用规范
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import './LandingPage.css';

const { Header, Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const TermsOfService = () => {
  return (
    <Layout className="landing-page">
      <Header className="landing-header">
        <div className="header-inner">
          <span className="footer-copy">blooart CAMPUS · 服务条款</span>
          <Link to="/" style={{ color: '#595959', textDecoration: 'none' }}>返回首页</Link>
        </div>
      </Header>
      <Content className="landing-body">
        <section className="section">
          <Title level={2} className="section-title">服务条款</Title>
          <Paragraph className="section-subtitle">
            欢迎使用 blooart CAMPUS 教育管理平台（以下简称「本平台」）。本平台面向机构/学校提供在线排课、文件管理、多通道通知（含邮件、企业微信、WhatsApp）、Google 日历同步等服务。
          </Paragraph>

          <Title level={4}>一、服务对象</Title>
          <Paragraph>
            本平台仅向合法设立的机构/学校及其授权的管理员、老师、学生提供服务。机构/学校应确保在录入老师、学生信息及使用本平台前，已取得必要的授权和同意。
          </Paragraph>

          <Title level={4}>二、账号与安全</Title>
          <Paragraph>
            机构/学校负责创建和管理本平台账号，并对账号下的所有操作负责。您应妥善保管账号和密码，不得向未授权人员泄露或转让。
          </Paragraph>

          <Title level={4}>三、WhatsApp 使用规范</Title>
          <Paragraph>
            1. 本平台提供 <strong>WhatsApp</strong> 通知能力，仅用于：向已同意接收通知的老师、学生发送课程提醒、上课链接、作业/考试提醒等教学相关通知；与教学服务直接相关的必要服务通知。
          </Paragraph>
          <Paragraph>
            2. 您同意<strong>不将本平台用于</strong>：向陌生号码群发营销信息或垃圾信息；与诈骗、灰色产业、违法活动相关的任何用途；违反 Meta / WhatsApp 使用政策或商业政策的行为。
          </Paragraph>
          <Paragraph>
            3. 如因您的违规使用导致 Meta / WhatsApp 封禁号码或采取限制措施，由您自行承担责任。使用 WhatsApp 能力时，您需确保符合 Meta 官网要求与审核规定。
          </Paragraph>

          <Title level={4}>四、企业微信使用规范</Title>
          <Paragraph>
            1. 本平台提供的 <strong>企业微信（WeChat Work）</strong> 通知能力，仅用于：向已加入机构/学校企业微信组织的成员发送课程、排课、作业/考试等教学相关通知；与教学管理直接相关的系统通知。
          </Paragraph>
          <Paragraph>
            2. 您同意：仅向已授权接收通知的成员发送消息，不向企业外或未授权用户群发；遵守腾讯企业微信平台的使用规范与开发者协议；不利用企业微信通道发送营销、广告或与教育无关的内容。
          </Paragraph>
          <Paragraph>
            3. 企业微信应用与权限由您在自身企业微信管理后台配置，因配置或使用不当导致的限制或封禁由您自行承担责任。
          </Paragraph>

          <Title level={4}>五、Google 日历使用规范</Title>
          <Paragraph>
            1. 本平台提供的 <strong>Google Calendar（Google 日历）</strong> 同步功能，仅用于：在您或机构授权范围内读取日历事件，用于排课展示与冲突检测；将本平台创建的课程与上课时间写入授权日历，便于多端查看与提醒。
          </Paragraph>
          <Paragraph>
            2. 您同意：仅对您拥有合法权限的 Google 日历进行授权，不将他人日历在未授权情况下接入本平台；遵守 Google API 服务条款与用户数据政策；不利用本平台对 Google 日历的访问进行与教育服务无关的数据采集或滥用。
          </Paragraph>
          <Paragraph>
            3. 因 Google 服务条款变更、配额或风控导致的同步失败或限制，本平台将尽力配合说明，但不承担第三方责任。
          </Paragraph>

          <Title level={4}>六、数据与内容</Title>
          <Paragraph>
            您在本平台上传、录入的课程内容、文件资料、联系人信息等，仍归您或所属机构/学校所有。您授权本平台在提供服务的必要范围内，对上述数据进行存储、备份和处理。通过 WhatsApp、企业微信、Google 日历等第三方服务产生的数据，同时受各平台政策约束。
          </Paragraph>

          <Title level={4}>七、责任限制</Title>
          <Paragraph>
            本平台将尽力保障服务的稳定性，但不对因不可抗力、第三方服务（如 Meta、腾讯、Google）故障或政策变更等造成的服务中断、数据丢失承担赔偿责任。对于因您自身原因（如账号泄露、配置错误、违规使用第三方通道）造成的损失，由您自行承担。
          </Paragraph>

          <Title level={4}>八、条款更新</Title>
          <Paragraph>
            我们可能根据法律法规、监管要求或业务调整更新本服务条款。更新后的条款将在官网公示，若您继续使用本平台，即视为接受更新后的条款。如对本服务条款有任何疑问，可通过官网「联系我们」中的联系方式与我们取得联系。
          </Paragraph>
        </section>
      </Content>
      <Footer className="landing-footer">
        <div className="footer-inner">
          <Link to="/">首页</Link>
          <Link to="/privacy">隐私政策</Link>
          <span className="footer-copy">blooart CAMPUS</span>
        </div>
      </Footer>
    </Layout>
  );
};

export default TermsOfService;
